import * as React from 'react';
import { PaymentResult } from '../../PaymentResult';
import tickImage from '../../../assets/tick.png';

interface IProps {
  onClick(): void;
}

export const Subscription = (props: IProps) => {
  const { onClick } = props;

  return (
    <PaymentResult
      image={tickImage}
      title="Подписка оплачена"
      description="Можете использовать её при размещении объявления"
      buttonTitle="Хорошо"
      onClick={onClick}
    />
  );
};
